export default {
  namespaced: true,

  state: {
    currentProvider: ''
  },

  mutations: {

    setCurrentProvider(state, payload) {
      if (state.currentProvider === '') {
        state.currentProvider = payload;
      }
    }
  },

  actions: {
    setCurrentProvider(context, payload) {
      context.commit('setCurrentProvider', payload);
    }
  },
};
